export const combineRefs = refs => {
  return el => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(el);
      } else if (ref) {
        // eslint-disable-next-line no-param-reassign
        ref.current = el;
      }
    });
  };
};
//# sourceMappingURL=ref.js.map